import { useCallback, useRef } from "react"

// biome-ignore lint/suspicious/noExplicitAny: This is fine 🔥
export const useStableFunction = <Func extends (...args: any[]) => any>(
  fn: Func,
): ((...args: Parameters<Func>) => ReturnType<Func>) => {
  const functionRef = useRef(fn)

  functionRef.current = fn

  return useCallback(
    (...args: Parameters<Func>) => functionRef.current(...args),
    [],
  )
}
